import { useContext } from 'react';
import { DataTableSelectionContext } from 'src/components/DataTable/components/DataTableSelectionProvider/DataTableSelectionContext';
import { SelectionContextValue } from 'src/components/DataTable/types/DataTableSelection';

export function useDataTableSelectionContext(): SelectionContextValue {
  const context = useContext(DataTableSelectionContext);

  if (!context) {
    throw new Error(
      'useDataTableSelectionContext must be used within a DataTableSelectionProvider'
    );
  }

  return context;
}
